import { ONE_GIGABYTE, ONE_KILOBYTE, ONE_MEGABYTE } from '@lucidlink/uicore';
import { RATE_LIMIT_UNITS } from '#constants';
export const convertRateLimitFloat = ({ unit, value, }) => {
    const isFloat = value % 1 !== 0;
    if (isFloat) {
        const currentUnitIndex = RATE_LIMIT_UNITS.indexOf(unit);
        const hasLowerUnit = currentUnitIndex > 0;
        if (hasLowerUnit) {
            const lowerUnit = RATE_LIMIT_UNITS[currentUnitIndex - 1];
            return convertRateLimitFloat({
                value: value * ONE_KILOBYTE,
                unit: lowerUnit,
            });
        }
        else {
            // Already at KB/s (smallest unit), floor the decimal value
            // e.g., 1.5 KB/s → 1 KB/s, 2.9 KB/s → 2 KB/s
            // If floored value is 0, return 1 (values < 1 KB/s display as 1 KB/s)
            // This is a product decision.
            const flooredValue = Math.floor(value);
            return { value: flooredValue < 1 ? 1 : flooredValue, unit };
        }
    }
    return { value, unit };
};
export const rateLimitToValueAndUnit = (bytesPerSecond) => {
    // Determine the appropriate unit based on byte ranges
    // Use the largest unit where the value is >= 1
    switch (true) {
        // Values less than 1 KB/s should display as 1 KB/s
        case bytesPerSecond > 0 && bytesPerSecond < ONE_KILOBYTE:
            return {
                value: 1,
                unit: RATE_LIMIT_UNITS[0],
            };
        case bytesPerSecond === 0:
            return {
                value: 0,
                unit: RATE_LIMIT_UNITS[0],
            };
        case bytesPerSecond >= ONE_GIGABYTE:
            return {
                value: bytesPerSecond / ONE_GIGABYTE,
                unit: RATE_LIMIT_UNITS[2],
            };
        case bytesPerSecond >= ONE_MEGABYTE:
            return {
                value: bytesPerSecond / ONE_MEGABYTE,
                unit: RATE_LIMIT_UNITS[1],
            };
        default:
            return {
                value: bytesPerSecond / ONE_KILOBYTE,
                unit: RATE_LIMIT_UNITS[0],
            };
    }
};
